import React from 'react';
import styles from './styles/date-filter.module.scss';
import { motion } from 'motion/react';

function DateFilter({ text, selected, onClick }) {
    return (
        <motion.button whileHover={{ scale: 1.05 }} className={`${styles.dateFilter} ${selected ? styles.selected : ''}`} onClick={onClick}>
            <p className={`${styles.text} ${selected ? styles.selected : ''}`}>{text}</p>
        </motion.button>
    );
}

export default DateFilter;
